var _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaceOutlinedWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "place",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_388",
    "data-name": "Rectangle 388",
    width: 16,
    height: 20,
    fill: "#333"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 24,
    height: 24,
    fill: "#334856",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1986",
    "data-name": "Groupe 1986",
    transform: "translate(4 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1985",
    "data-name": "Groupe 1985",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_642",
    "data-name": "Trac\\xE9 642",
    d: "M8,10a2,2,0,1,1,2-2,2.006,2.006,0,0,1-2,2m6-1.8A5.954,5.954,0,0,0,8,2,5.954,5.954,0,0,0,2,8.2c0,2.34,1.95,5.44,6,9.14,4.05-3.7,6-6.8,6-9.14M8,0a7.955,7.955,0,0,1,8,8.2Q16,13.18,8,20,.005,13.175,0,8.2A7.955,7.955,0,0,1,8,0",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceOutlinedWhite);
export default __webpack_public_path__ + "static/media/PlaceOutlinedWhite.af3bf9dea5a5803079a6d50239e6cc57.svg";
export { ForwardRef as ReactComponent };